// Система локализации
export type Language = 'ru' | 'en';

export const translations: Record<Language, Record<string, string>> = {
  ru: {
    // Меню Файл
    'menu.file': 'Файл',
    'menu.new.project': 'Новый проект',
    'menu.open': 'Открыть',
    'menu.open.project': 'Проект',
    'menu.open.model': 'Модель',
    'menu.save.project': 'Сохранить',
    'menu.language': 'Язык',
    'menu.language.russian': 'Русский',
    'menu.language.english': 'English',
    'menu.settings': 'Настройки',
    'menu.debug': 'Эффекты',
    'menu.info': 'Сведения',
    
    // Effects panel (former Debug panel)
    'effects.title': 'ЭФФЕКТЫ',
    'effects.experimental': 'Экспериментальные функции. Используйте с осторожностью.',
    'effects.renderer': 'РЕНДЕРЕР',
    'effects.postprocessing': 'ПОСТОБРАБОТКА',
    'effects.bloom': 'СВЕЧЕНИЕ (BLOOM)',
    'effects.dof': 'ГЛУБИНА РЕЗКОСТИ (DOF)',
    'effects.film': 'ПЛЁНКА / ЗЕРНО',
    'effects.color': 'ЦВЕТОКОРРЕКЦИЯ',
    'effects.ssao': 'AMBIENT OCCLUSION (SSAO)',
    'effects.shadows': 'ТЕНИ (SHADOWS)',
    'effects.antialiasing': 'АНТИАЛИАСИНГ',
    'effects.camera': 'КАМЕРА',
    'effects.fog': 'ТУМАН',
    'effects.print.offset': 'ПРИНТ OFFSET',
    'effects.reset': 'Сбросить к умолчанию',
    
    // Photo angles
    'photo.angle.front': 'Спереди',
    'photo.angle.front.left': 'Спереди 45° (слева)',
    'photo.angle.side.left': 'Сбоку (слева)',
    'photo.angle.back.left': 'Сзади 45° (слева)',
    'photo.angle.back': 'Сзади',
    'photo.angle.back.right': 'Сзади 45° (справа)',
    'photo.angle.side.right': 'Сбоку (справа)',
    'photo.angle.front.right': 'Спереди 45° (справа)',

    // Photo export modes
    'photo.export.one': 'Экспорт одного фото',
    'photo.export.batch': 'Пакетный экспорт всех ракурсов',
    
    // Performance mode / FPS hint
    'perf.low.message': 'Если модель двигается с рывками – включите оптимизацию',
    'perf.low.tooltip': 'В этом режиме понижается разрешение рендера только в редакторе. Экспорт фото и видео сохраняется в полном качестве. Оптимизацию всегда можно включить в настройках',
    'perf.enabled.message': 'Оптимизацию всегда можно включить в настройках',
    'perf.menu.optimization': 'Оптимизация',
    'perf.badge.on': 'Оптимизация ВКЛ',
    'perf.badge.title': 'Нажмите, чтобы открыть настройки',

    // Settings modal
    'settings.title': 'Настройки',
    'settings.title.upper': 'НАСТРОЙКИ',
    'settings.nav.general': 'ОБЩИЕ',
    'settings.nav.hotkeys': 'ГОРЯЧИЕ КЛАВИШИ',
    'settings.nav.optimization': 'ОПТИМИЗАЦИЯ',
    'settings.nav.effects': 'ЭФФЕКТЫ',
    'settings.nav.info': 'СВЕДЕНИЯ',
    'settings.general.rotate': 'ВРАЩАТЬ КУРСОРОМ',
    'settings.general.simplified': 'УПРОЩЕННЫЙ ИНТЕРФЕЙС',
    'settings.general.simplified.help': 'Показывает снизу справа кнопки которые регулируют угол модели. Ровно спереди/сбоку справа/спина/сбоку слева',
    'settings.general.language': 'ЯЗЫК',
    'settings.navigation.title': 'Навигация',
    'settings.navigation.rotate.label': 'Вращать курсором',
    'settings.navigation.rotate.scene': 'Сцену',
    'settings.navigation.rotate.model': 'Модель',
    'settings.navigation.rotate.hint': 'В режиме “Модель” зум и панорамирование остаются как обычно.',
    'settings.angles.title': 'Ракурсы',
    'settings.optimization.title': 'Оптимизация',
    'settings.optimization.toggle': 'Режим оптимизации',
    'settings.optimization.note': 'Качество экспорта фото/видео не меняется.',

    // Hotkeys
    'hotkeys.rotate.scene': 'Вращение сцены',
    'hotkeys.move.scene': 'Перемещение сцены',
    'hotkeys.mouse.left': 'ЛКМ',
    'hotkeys.mouse.right': 'ПКМ',
    'hotkeys.and.drag': '+ движение',
    'hotkeys.save': 'Сохранение проекта',
    'hotkeys.undo': 'Шаг назад (в режиме принтов)',
    'hotkeys.redo': 'Шаг вперед (в режиме принтов)',
    'hotkeys.delete': 'Удаление принта',
    'hotkeys.angles': 'Поворот модели (1-8 ракурсов)',
    'hotkeys.reset.view': 'Сброс вида модели',

    // Tutorial banner
    'tutorial.watch': 'Посмотреть обучение',
    'tutorial.link': 'Смотреть →',

    // Training panel (PiP)
    'training.title': 'ОБУЧЕНИЕ',
    'training.back': 'Назад к урокам',
    'training.close': 'Закрыть обучение',

    // Help button
    'help.title': 'Помощь',

    // Toolbar buttons
    'toolbar.center.view': 'Центрировать вид',
    'toolbar.screenshot': 'Сделать фото',
    'toolbar.rotate.model': 'Поворот модели',
    'toolbar.cinema.mode': 'Режим Cinema',
    'toolbar.goto.start': 'К началу',
    'toolbar.play': 'Воспроизвести',
    'toolbar.stop': 'Остановить',
    'toolbar.goto.end': 'К концу',
    
    // Панель слоёв
    'panel.layers': 'СЛОИ',
    'panel.layers.add': 'Добавить принт +',
    
    // Панель материалов
    'panel.materials': 'МАТЕРИАЛЫ',
    'panel.materials.select': 'Выберите материал',
    
    // Панель сцены
    'panel.scene': 'СЦЕНА',
    'panel.scene.environment': 'ОКРУЖЕНИЕ',
    'panel.scene.environment.night': 'Ночная сцена',
    'panel.scene.environment.photostudio': 'Дневной свет',
    'panel.scene.environment.daylight': 'Фотостудия',
    'panel.scene.environment.none': 'Без окружения',
    'panel.scene.reflectivity': 'Отражение',
    'panel.scene.background': 'ФОН',
    'panel.scene.bg.transparent': 'Прозрачный',
    'panel.scene.bg.solid': 'Монотонный',
    'panel.scene.bg.gradient': 'Градиент',
    'panel.scene.fov': 'Угол обзора',
    'panel.aspect.ratio.free': 'Авто',
    'panel.aspect.ratio.1:1': '1:1',
    'panel.aspect.ratio.16:9': '16:9',
    'panel.aspect.ratio.9:16': '9:16',
    
    // Панель материала
    'panel.material': 'МАТЕРИАЛ',
    'panel.material.color': 'Цвет',
    'panel.material.tiling': 'Размер',
    'panel.material.rotation': 'Поворот',
    'panel.material.reflectivity': 'Отражение',
    'panel.material.roughness': 'Шероховатость',
    'panel.material.roughness.texture': 'Текст. шерох.',
    'panel.material.metalness': 'Металличность',
    'panel.material.normal': 'Рельеф',
    
    // Панель освещения
    'panel.lighting': 'ОСВЕЩЕНИЕ',
    'panel.lighting.top': 'Верхний свет',
    'panel.lighting.bottom': 'Нижний свет',
    'panel.lighting.left': 'Контровой свет (левый)',
    'panel.lighting.right': 'Контровой свет (правый)',
    'panel.lighting.distance': 'Расстояние',
    'panel.lighting.intensity': 'Интенсивность',
    'panel.lighting.color': 'Цвет света',
    'panel.lighting.reset': 'Сбросить освещение',
    
    // Кнопки камеры
    'camera.center': 'Центрировать вид',
    'camera.panel': 'Панель камеры',
    'camera.rotate': 'Поворот модели',
    'camera.animation': 'Камера (8 c)',
    'camera.start': 'Старт',
    'camera.end': 'Финал',
    'camera.preview': 'Просмотр',
    'camera.arc': 'Дуга',
    'camera.arc.short': 'Короткая дуга',
    'camera.arc.long': 'Длинная дуга',
    'camera.arc.turntable': 'Вращение',
    'camera.export': 'Экспорт',
    // Loading
    'loading.export.photos': 'экспорт фото',
    'loading.export.photos.zip': 'сборка архива',
    'loading.export.photos.save': 'Куда сохранить архив?',
    'loading.export.photos.ready': 'архив готов',
    'loading.save.archive': 'Сохранить архив',
    
    // Messages
    'message.photos.exported': 'Фото экспортированы',
    'camera.seconds': 'с',
    'camera.points.none': 'Точек нет',
    'camera.points.start': 'Старт задан',
    'camera.points.end': 'Финал задан',
    'camera.points.ready': 'Готово к записи',
    'camera.error.noframes': 'Сначала задайте стартовый и конечный кадр',
    'camera.start.set': 'Начальный кадр установлен',
    'camera.end.set': 'Конечный кадр установлен',
    
    // Панель сведений
    'info.title': 'Сведения',
    'info.fps': 'FPS',
    'info.polygons': 'Полигонов',
    'info.objects': 'Объектов',
    'info.project': 'Проект',
    'info.worktime': 'Время',
    'info.gpu': 'GPU',
    'info.untitled': 'Без названия',
    
    // Диалоги
    'dialog.delete.title': 'Удалить слой?',
    'dialog.delete.message': 'Это действие нельзя отменить',
    'dialog.delete.confirm': 'Удалить',
    'dialog.delete.cancel': 'Отмена',
    'dialog.close.title': 'Закрыть редактор?',
    'dialog.close.message': 'Несохранённые изменения будут потеряны',
    'dialog.close.confirm': 'Закрыть',
    'dialog.close.cancel': 'Отмена',
    
    // Сообщения
    'message.subscription.expired': 'Подписка истекла. Загрузка моделей недоступна.',
    'message.subscription.renew': 'Продлить',
    'message.loading': 'загрузка',
    'loading.export.video': 'экспорт видео',
    'loading.render.video': 'рендеринг видео',
    'loading.save.video': 'сохранение видео',
    'loading.build.mp4': 'сборка MP4',
    'loading.video.eta': 'Примерное время:',
    'loading.video.warning': 'Не закрывайте вкладку и не меняйте размер окна браузера',
    'loading.load.model': 'загрузка модели',
    'loading.save.project': 'сохранение проекта',
    'loading.load.project': 'загрузка проекта',
    'loading.cancel': 'Отмена',
    'message.render.cancelled': 'Рендеринг отменён',
    
    // Авторизация
    'auth.login': 'Вход',
    'auth.email': 'Email',
    'auth.password': 'Пароль',
    'auth.submit': 'Войти',
    'auth.error': 'Ошибка авторизации',
    
    // Меню пользователя
    'user.account': 'Аккаунт',
    'user.admin': 'Админ-панель',
    'user.tutorial': 'Обучение',
    'user.support': 'Написать в поддержку',
    'user.logout': 'Выйти',
    'user.expires': 'до',
    
    // 2D редактор
    'editor.close': 'Закрыть',
    'editor.add.image': 'Добавить изображение',
    'editor.exposure': 'Экспозиция',
    'editor.contrast': 'Контраст',
    'editor.hint.select': 'Выделите изображение, чтобы применить настройки',
    'editor.mask.create': 'Создать маску',
    'editor.mask.cancel': 'Отмена (Esc)',
    'editor.mask.remove': 'Удалить маску',
    'editor.mask.hint': 'Нарисуйте область маски: клик — точка, замкните на первую точку или нажмите Enter. Esc — отмена.',
    'editor.mask.select.object': 'Сначала выберите один объект, чтобы создать маску',
    'editor.confirm.save.title': 'сохранить изменения?',
    'editor.confirm.save.yes': 'Сохранить',
    'editor.confirm.save.no': 'Не сохранять',
    'editor.confirm.save.cancel': 'Отмена',
    
    // Loading indicators
    'loading.material': 'применение материала',
    'loading.hdri': 'загрузка окружения',
    'loading.editor': 'загрузка редактора',
    
    // WebGL Error
    'error.webgl.title': 'не удалось запустить',
    'error.webgl.description': 'Закройте лишние вкладки или перезагрузите компьютер',
    'error.webgl.retry': 'Попробовать снова',
    'editor.error.add.image': 'Не удалось добавить изображение',
    'editor.confirm.clear': 'Вы уверены, что хотите очистить холст?',
    'editor.error.load': 'Не удалось загрузить принт для редактирования',
    
    // Ошибки и предупреждения
    'error.load.model.first': 'Сначала загрузите модель',
    'error.save.project': 'Ошибка сохранения проекта',
    'error.load.project': 'Ошибка загрузки проекта',
    'error.recording.active': 'Запись уже идёт',
    'error.browser.recording': 'Браузер не поддерживает запись canvas',
    'error.init.recording': 'Не удалось инициализировать запись видео',
    'error.load.light.preset': 'Ошибка загрузки светового пресета',
    'error.select.layer': 'Сначала выберите слой слева',
    'error.preset': 'Ошибка пресета',
    'error.gltf': 'Ошибка GLTF',
    'error.obj': 'Ошибка OBJ',
    'message.subscription.contact': 'Свяжитесь с поддержкой для продления подписки',
    'message.tutorial.coming': 'Ссылка на обучение будет добавлена позже',
    'message.support.coming': 'Ссылка на поддержку будет добавлена позже',
  },
  
  en: {
    // File menu
    'menu.file': 'File',
    'menu.new.project': 'New Project',
    'menu.open': 'Open',
    'menu.open.project': 'Project',
    'menu.open.model': 'Model',
    'menu.save.project': 'Save',
    'menu.language': 'Language',
    'menu.language.russian': 'Русский',
    'menu.language.english': 'English',
    'menu.settings': 'Settings',
    'menu.debug': 'Effects',
    'menu.info': 'Info',
    
    // Effects panel (former Debug panel)
    'effects.title': 'EFFECTS',
    'effects.experimental': 'Experimental features. Use with caution.',
    'effects.renderer': 'RENDERER',
    'effects.postprocessing': 'POSTPROCESSING',
    'effects.bloom': 'BLOOM',
    'effects.dof': 'DEPTH OF FIELD (DOF)',
    'effects.film': 'FILM / GRAIN',
    'effects.color': 'COLOR CORRECTION',
    'effects.ssao': 'AMBIENT OCCLUSION (SSAO)',
    'effects.shadows': 'SHADOWS',
    'effects.antialiasing': 'ANTI-ALIASING',
    'effects.camera': 'CAMERA',
    'effects.fog': 'FOG',
    'effects.print.offset': 'PRINT OFFSET',
    'effects.reset': 'Reset to default',
    
    // Photo angles
    'photo.angle.front': 'Front',
    'photo.angle.front.left': 'Front 45° (left)',
    'photo.angle.side.left': 'Side (left)',
    'photo.angle.back.left': 'Back 45° (left)',
    'photo.angle.back': 'Back',
    'photo.angle.back.right': 'Back 45° (right)',
    'photo.angle.side.right': 'Side (right)',
    'photo.angle.front.right': 'Front 45° (right)',

    // Photo export modes
    'photo.export.one': 'Export one photo',
    'photo.export.batch': 'Batch export all angles',
    
    // Performance mode / FPS hint
    'perf.low.message': 'For a more comfortable experience you can enable optimization mode.',
    'perf.low.tooltip': 'In this mode we reduce render resolution only in the editor. Photo and video export stays at full quality. You can always enable optimization in settings.',
    'perf.enabled.message': 'You can always enable optimization in settings.',
    'perf.menu.optimization': 'Optimization',
    'perf.badge.on': 'Optimization ON',
    'perf.badge.title': 'Click to open settings',

    // Settings modal
    'settings.title': 'Settings',
    'settings.title.upper': 'SETTINGS',
    'settings.nav.general': 'GENERAL',
    'settings.nav.hotkeys': 'HOTKEYS',
    'settings.nav.optimization': 'OPTIMIZATION',
    'settings.nav.effects': 'EFFECTS',
    'settings.nav.info': 'INFO',
    'settings.general.rotate': 'ROTATE WITH CURSOR',
    'settings.general.simplified': 'SIMPLIFIED UI',
    'settings.general.simplified.help': 'Shows bottom-right buttons to set model angle: front / right side / back / left side.',
    'settings.general.language': 'LANGUAGE',
    'settings.navigation.title': 'Navigation',
    'settings.navigation.rotate.label': 'Rotate with cursor',
    'settings.navigation.rotate.scene': 'Scene',
    'settings.navigation.rotate.model': 'Model',
    'settings.navigation.rotate.hint': 'In “Model” mode, zoom and pan work as usual.',
    'settings.angles.title': 'Angles',
    'settings.optimization.title': 'Optimization',
    'settings.optimization.toggle': 'Optimization mode',
    'settings.optimization.note': 'Photo/video export quality is not affected.',

    // Hotkeys
    'hotkeys.rotate.scene': 'Rotate scene',
    'hotkeys.move.scene': 'Move scene',
    'hotkeys.mouse.left': 'LMB',
    'hotkeys.mouse.right': 'RMB',
    'hotkeys.and.drag': '+ drag',
    'hotkeys.save': 'Save project',
    'hotkeys.undo': 'Undo (in print mode)',
    'hotkeys.redo': 'Redo (in print mode)',
    'hotkeys.delete': 'Delete print',
    'hotkeys.angles': 'Rotate model (1-8 angles)',
    'hotkeys.reset.view': 'Reset view',

    // Tutorial banner
    'tutorial.watch': 'Watch tutorial',
    'tutorial.link': 'Watch →',

    // Training panel (PiP)
    'training.title': 'TUTORIAL',
    'training.back': 'Back to lessons',
    'training.close': 'Close tutorial',

    // Help button
    'help.title': 'Help',

    // Toolbar buttons
    'toolbar.center.view': 'Center View',
    'toolbar.screenshot': 'Take Photo',
    'toolbar.rotate.model': 'Rotate Model',
    'toolbar.cinema.mode': 'Cinema Mode',
    'toolbar.goto.start': 'To Start',
    'toolbar.play': 'Play',
    'toolbar.stop': 'Stop',
    'toolbar.goto.end': 'To End',
    
    // Layers panel
    'panel.layers': 'LAYERS',
    'panel.layers.add': 'Add Design +',
    
    // Materials panel
    'panel.materials': 'MATERIALS',
    'panel.materials.select': 'Select material',
    
    // Scene panel
    'panel.scene': 'SCENE',
    'panel.scene.environment': 'HDRI Environment',
    'panel.scene.environment.night': 'Night Scene',
    'panel.scene.environment.photostudio': 'Daylight',
    'panel.scene.environment.daylight': 'Photo Studio',
    'panel.scene.environment.none': 'No Environment',
    'panel.scene.reflectivity': 'Reflectivity',
    'panel.scene.background': 'BACKGROUND',
    'panel.scene.bg.transparent': 'Transparent',
    'panel.scene.bg.solid': 'Solid',
    'panel.scene.bg.gradient': 'Gradient',
    'panel.scene.fov': 'Field of View',
    'panel.aspect.ratio.free': 'Auto',
    'panel.aspect.ratio.1:1': '1:1',
    'panel.aspect.ratio.16:9': '16:9',
    'panel.aspect.ratio.9:16': '9:16',
    
    // Material panel
    'panel.material': 'MATERIAL',
    'panel.material.color': 'Color',
    'panel.material.tiling': 'Size',
    'panel.material.rotation': 'Rotation',
    'panel.material.reflectivity': 'Reflectivity',
    'panel.material.roughness': 'Roughness',
    'panel.material.roughness.texture': 'Roughness Mult',
    'panel.material.metalness': 'Metalness',
    'panel.material.normal': 'Normal Scale',
    
    // Lighting panel
    'panel.lighting': 'LIGHTING',
    'panel.lighting.top': 'Top Light',
    'panel.lighting.bottom': 'Bottom Light',
    'panel.lighting.left': 'Rim Light (left)',
    'panel.lighting.right': 'Rim Light (right)',
    'panel.lighting.distance': 'Distance',
    'panel.lighting.intensity': 'Intensity',
    'panel.lighting.color': 'Light Color',
    'panel.lighting.reset': 'Reset lighting',
    
    // Camera buttons
    'camera.center': 'Center View',
    'camera.panel': 'Camera Panel',
    'camera.rotate': 'Rotate Model',
    'camera.animation': 'Camera (8 s)',
    'camera.start': 'Start',
    'camera.end': 'End',
    'camera.preview': 'Preview',
    'camera.arc': 'Arc',
    'camera.arc.short': 'Short Arc',
    'camera.arc.long': 'Long Arc',
    'camera.arc.turntable': 'Turntable',
    'camera.export': 'Export',
    // Loading
    'loading.export.photos': 'Exporting photos…',
    'loading.export.photos.zip': 'Building archive…',
    'loading.export.photos.save': 'Choose where to save…',
    'loading.export.photos.ready': 'Archive is ready',
    'loading.save.archive': 'Save archive',
    
    // Messages
    'message.photos.exported': 'Photos exported',
    'camera.seconds': 's',
    'camera.points.none': 'No points set',
    'camera.points.start': 'Start set',
    'camera.points.end': 'End set',
    'camera.points.ready': 'Ready to record',
    'camera.error.noframes': 'Set start and end frames first',
    'camera.start.set': 'Start frame set',
    'camera.end.set': 'End frame set',
    
    // Info panel
    'info.title': 'Info',
    'info.fps': 'FPS',
    'info.polygons': 'Polygons',
    'info.objects': 'Objects',
    'info.project': 'Project',
    'info.worktime': 'Time',
    'info.gpu': 'GPU',
    'info.untitled': 'Untitled',
    
    // Dialogs
    'dialog.delete.title': 'Delete layer?',
    'dialog.delete.message': 'This action cannot be undone',
    'dialog.delete.confirm': 'Delete',
    'dialog.delete.cancel': 'Cancel',
    'dialog.close.title': 'Close editor?',
    'dialog.close.message': 'Unsaved changes will be lost',
    'dialog.close.confirm': 'Close',
    'dialog.close.cancel': 'Cancel',
    
    // Messages
    'message.subscription.expired': 'Subscription expired. Model loading unavailable.',
    'message.subscription.renew': 'Renew',
    'message.loading': 'loading',
    'loading.export.video': 'exporting video',
    'loading.render.video': 'rendering video',
    'loading.save.video': 'saving video',
    'loading.build.mp4': 'building MP4',
    'loading.video.eta': 'Estimated time:',
    'loading.video.warning': 'Do not close the tab or resize the browser window',
    'loading.load.model': 'loading model',
    'loading.save.project': 'saving project',
    'loading.load.project': 'loading project',
    'loading.cancel': 'Cancel',
    'message.render.cancelled': 'rendering cancelled',
    
    // Auth
    'auth.login': 'Login',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.submit': 'Sign In',
    'auth.error': 'Authorization error',
    
    // User menu
    'user.account': 'Account',
    'user.admin': 'Admin Panel',
    'user.tutorial': 'Tutorial',
    'user.support': 'Contact Support',
    'user.logout': 'Log Out',
    'user.expires': 'until',
    
    // 2D Editor
    'editor.close': 'Close',
    'editor.add.image': 'Add Image',
    'editor.exposure': 'Exposure',
    'editor.contrast': 'Contrast',
    'editor.hint.select': 'Select an image to apply settings',
    'editor.mask.create': 'Create mask',
    'editor.mask.cancel': 'Cancel (Esc)',
    'editor.mask.remove': 'Remove mask',
    'editor.mask.hint': 'Draw mask area: click to add points, close on the first point or press Enter. Esc cancels.',
    'editor.mask.select.object': 'Select a single object to create a mask',
    'editor.confirm.save.title': 'Save changes?',
    'editor.confirm.save.yes': 'Save',
    'editor.confirm.save.no': "Don't save",
    'editor.confirm.save.cancel': 'Cancel',
    
    // Loading indicators
    'loading.material': 'applying material',
    'loading.hdri': 'loading environment',
    'loading.editor': 'loading editor',
    
    // WebGL Error
    'error.webgl.title': 'failed to start',
    'error.webgl.description': 'Close extra tabs or restart your computer',
    'error.webgl.retry': 'Try again',
    'editor.error.add.image': 'Failed to add image',
    'editor.confirm.clear': 'Are you sure you want to clear the canvas?',
    'editor.error.load': 'Failed to load design for editing',
    
    // Errors and warnings
    'error.load.model.first': 'Load model first',
    'error.save.project': 'Error saving project',
    'error.load.project': 'Error loading project',
    'error.recording.active': 'Recording already in progress',
    'error.browser.recording': 'Browser does not support canvas recording',
    'error.init.recording': 'Failed to initialize video recording',
    'error.load.light.preset': 'Error loading light preset',
    'error.select.layer': 'Select a layer on the left first',
    'error.preset': 'Preset error',
    'error.gltf': 'GLTF Error',
    'error.obj': 'OBJ Error',
    'message.subscription.contact': 'Contact support to renew subscription',
    'message.tutorial.coming': 'Tutorial link will be added later',
    'message.support.coming': 'Support link will be added later',
  }
};

class I18n {
  private currentLanguage: Language = 'ru';
  private listeners: Array<() => void> = [];
  
  constructor() {
    // Загружаем сохранённый язык
    const saved = localStorage.getItem('fabrica_language') as Language;
    if (saved && (saved === 'ru' || saved === 'en')) {
      this.currentLanguage = saved;
    }
  }
  
  get language(): Language {
    return this.currentLanguage;
  }
  
  setLanguage(lang: Language): void {
    if (lang !== this.currentLanguage) {
      this.currentLanguage = lang;
      localStorage.setItem('fabrica_language', lang);
      this.updateAllElements();
      this.notifyListeners();
    }
  }
  
  t(key: string): string {
    return translations[this.currentLanguage][key] || key;
  }
  
  // Обновить все элементы с data-i18n
  updateAllElements(): void {
    // Обновить обычные элементы
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (key) {
        if (el instanceof HTMLOptionElement) {
          el.textContent = this.t(key);
        } else {
          el.textContent = this.t(key);
        }
      }
    });
    
    // Обновить placeholder'ы
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
      const key = el.getAttribute('data-i18n-placeholder');
      if (key && el instanceof HTMLInputElement) {
        el.placeholder = this.t(key);
      }
    });
    
    // Обновить title'ы
    document.querySelectorAll('[data-i18n-title]').forEach(el => {
      const key = el.getAttribute('data-i18n-title');
      if (key) {
        el.setAttribute('title', this.t(key));
      }
    });
    
    // Обновить элементы внутри модальных окон (даже если они скрыты)
    const modal = document.getElementById('canvas-editor-modal');
    if (modal) {
      modal.querySelectorAll('[data-i18n]').forEach(el => {
        const key = el.getAttribute('data-i18n');
        if (key) {
          el.textContent = this.t(key);
        }
      });
    }
  }
  
  // Подписка на изменения языка
  onChange(callback: () => void): void {
    this.listeners.push(callback);
  }
  
  private notifyListeners(): void {
    this.listeners.forEach(cb => cb());
  }
}

// Singleton экземпляр
export const i18n = new I18n();

// Короткая функция для получения перевода
export const t = (key: string): string => i18n.t(key);

